import React from 'react'
import IconMenu from 'material-ui/IconMenu'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconButton from 'material-ui/IconButton'

import MenuItem from 'material-ui/MenuItem'

const ScannedTextList = ({ handleChange, scannedText }) => {
  return (
    <IconMenu
      onChange={handleChange}
      iconButtonElement={
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      }
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'top'
      }}
      targetOrigin={{
        horizontal: 'left',
        vertical: 'top'
      }}>
      {scannedText.map((item, index) => (
        <MenuItem
          key={index}
          value={item}
          primaryText={item}
        />
      ))}
    </IconMenu>
  )
}

export default ScannedTextList



// WEBPACK FOOTER //
// ./src/components/ScannedTextList.js